/**
 * Profile Notes logic (CRUD, Folders, Move)
 */
export const initNotes = (config) => {
    const noteForm = document.getElementById('profile-add-note-form');
    const noteToggle = document.getElementById('add-note-toggle');
    const noteFormWrapper = document.getElementById('add-note-form-wrapper');
    const placeholder = document.getElementById('add-note-form-placeholder');
    const filterContainer = document.getElementById('notes-filter-container');
    const notesContainer = document.querySelector('.profile-notes');
    const currentLang = config.lang || document.documentElement.lang || '';

    if (!noteForm) return;

    const adjustTabCount = (collection, delta) => {
        if (!filterContainer) return;
        const targetCol = collection || 'General';
        const btn = Array.from(filterContainer.querySelectorAll('.saved-filter__btn')).find(b => b.dataset.collection === targetCol);
        if (btn) {
            const countSpan = btn.querySelector('.saved-filter__count');
            if (countSpan) {
                const current = parseInt(countSpan.textContent, 10) || 0;
                countSpan.textContent = Math.max(0, current + delta);
            }
        }
    };

    const fetchNotesPage = async (page = 1, collection = null) => {
        if (!notesContainer) return;
        const activeBtn = filterContainer?.querySelector('.saved-filter__btn.is-active[data-collection]');
        const targetCol = collection !== null ? collection : (activeBtn ? activeBtn.dataset.collection : (notesContainer.dataset.activeCol || 'all'));

        const fd = new FormData();
        fd.append('action', 'united_auth_get_notes');
        fd.append('security', config.nonce);
        fd.append('page', page);
        fd.append('collection', targetCol);
        if (currentLang) fd.append('lang', currentLang);

        try {
            const response = await fetch(config.ajax_url, { method: 'POST', body: fd });
            const result = await response.json();
            if (result.success && result.data) {
                let list = document.getElementById('notes-list');
                let emptyState = document.getElementById('notes-empty-state');

                if (result.data.html && result.data.html.trim().length > 0) {
                    if (!list) {
                        list = document.createElement('div');
                        list.className = 'notes-list';
                        list.id = 'notes-list';
                        const pag = notesContainer.querySelector('.ua-pagination[data-collection="notes"]');
                        if (pag) {
                            notesContainer.insertBefore(list, pag);
                        } else {
                            notesContainer.appendChild(list);
                        }
                    }
                    list.innerHTML = result.data.html;
                    list.style.display = '';
                    if (emptyState) emptyState.style.display = 'none';
                } else {
                    if (list) list.style.display = 'none';
                    if (!emptyState) {
                        emptyState = document.createElement('div');
                        emptyState.className = 'profile-empty-state';
                        emptyState.id = 'notes-empty-state';
                        emptyState.innerHTML = '<i class="fa-solid fa-pen-to-square"></i><p>' + (config.i18n?.prof_notes_empty || 'Немає нотаток') + '</p>';
                        notesContainer.appendChild(emptyState);
                    }
                    emptyState.style.display = '';
                }

                let pagWrapper = notesContainer.querySelector('.ua-pagination[data-collection="notes"]');
                if (result.data.pagination) {
                    if (!pagWrapper) {
                        pagWrapper = document.createElement('div');
                        pagWrapper.className = 'ua-pagination';
                        pagWrapper.dataset.collection = 'notes';
                        notesContainer.appendChild(pagWrapper);
                    }
                    pagWrapper.innerHTML = result.data.pagination;
                } else if (pagWrapper) {
                    pagWrapper.remove();
                }

                notesContainer.dataset.currentPage = result.data.current_page;
                notesContainer.dataset.totalPages = result.data.total_pages;
                notesContainer.dataset.activeCol = result.data.collection;
            }
        } catch (err) {
            console.error('Fetch notes failed:', err);
        }
    };

    const moveForm = (target, show = true, isSaved = false) => {
        if (typeof tinyMCE !== 'undefined' && tinyMCE.get('note_content_editor')) {
            tinyMCE.execCommand('mceRemoveEditor', false, 'note_content_editor');
        }
        target.appendChild(noteFormWrapper);
        noteFormWrapper.style.display = show ? 'block' : 'none';
        noteFormWrapper.classList.toggle('is-inline-edit', target !== placeholder);
        noteFormWrapper.classList.toggle('is-saved-edit', isSaved);

        const actionInput = noteForm.querySelector('input[name="action"]');
        if (actionInput) actionInput.value = isSaved ? 'united_auth_update_saved' : 'united_auth_save_note';

        if (typeof tinyMCE !== 'undefined') {
            tinyMCE.execCommand('mceAddEditor', false, 'note_content_editor');
        }
    };

    const updateCollectionBadge = (el, folderName) => {
        if (!el) return;
        el.replaceChildren();
        const icon = document.createElement('i');
        icon.className = 'fa-solid fa-folder';
        el.appendChild(icon);
        el.appendChild(document.createTextNode(' ' + (folderName || (config.i18n?.folder_general || 'Загальна'))));
    };

    const setCollectionValue = (value = '') => {
        const select = document.getElementById('note-collection-select');
        const input = select?.querySelector('input[type="hidden"]');
        const option = Array.from(select?.querySelectorAll('.custom-select__option') || []).find((item) => item.dataset.value === value);
        if (!select || !input || !option) return;

        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        const label = select.querySelector('.custom-select__label');
        if (label) label.textContent = option.textContent.trim();
        select.querySelectorAll('.custom-select__option').forEach((item) => item.classList.toggle('selected', item === option));
    };

    const resetNoteForm = () => {
        noteForm.reset();
        const noteId = noteForm.querySelector('#note_id');
        if (noteId) noteId.value = '';
        setCollectionValue('');
        const feedback = noteForm.querySelector('.form-feedback');
        if (feedback) {
            feedback.replaceChildren();
            feedback.className = 'form-feedback';
        }
        if (typeof tinyMCE !== 'undefined' && tinyMCE.get('note_content_editor')) {
            tinyMCE.get('note_content_editor').setContent('');
        }
    };

    // Note form submission
    noteForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (typeof tinyMCE !== 'undefined' && tinyMCE.get('note_content_editor')) {
            tinyMCE.get('note_content_editor').save();
        }

        const feedback = noteForm.querySelector('.form-feedback');
        const submitBtn = noteForm.querySelector('button[type="submit"]');
        const formData = new FormData(noteForm);

        if (formData.get('note_collection') === '__new__' && !String(formData.get('note_new_folder_name') || '').trim()) {
            if (feedback) {
                feedback.textContent = config.i18n?.folder_name_required || 'Введіть назву нової папки.';
                feedback.className = 'form-feedback form-feedback--error is-visible';
            }
            noteForm.querySelector('#note_new_folder_name')?.focus();
            return;
        }

        if (!formData.has('action')) {
            formData.append('action', 'united_auth_save_note');
        }
        if (currentLang && !formData.has('lang')) {
            formData.append('lang', currentLang);
        }
        formData.append('security', config.nonce);

        submitBtn.disabled = true;
        if (feedback) {
            feedback.replaceChildren();
            const spinIcon = document.createElement('i');
            spinIcon.className = 'fa-solid fa-spinner fa-spin';
            feedback.appendChild(spinIcon);
            feedback.appendChild(document.createTextNode(' ' + (config.i18n?.saving || 'Збереження...')));
            feedback.className = 'form-feedback';
        }

        try {
            const response = await fetch(config.ajax_url, { method: 'POST', body: formData });
            const result = await response.json();
            submitBtn.disabled = false;

            if (result.success) {
                if (noteFormWrapper.classList.contains('is-inline-edit')) {
                    const isSaved = noteFormWrapper.classList.contains('is-saved-edit');
                    const id = String(formData.get(isSaved ? 'id' : 'note_id'));
                    const item = Array.from(document.querySelectorAll('.note-item, .saved-card')).find(el => el.dataset.id === id);
                    if (item) {
                        const contentTarget = item.querySelector(isSaved ? '.fragment-text' : '.note-item__content');
                        const oldCol = item.dataset.collection || '';
                        const newCol = isSaved ? oldCol : (result.data?.collection ?? formData.get('note_collection') ?? '');
                        if (contentTarget) {
                            contentTarget.innerHTML = formData.get(isSaved ? 'content' : 'note_content');
                        }
                        if (!isSaved) {
                            item.dataset.collection = newCol;
                            updateCollectionBadge(item.querySelector('.note-item__collection'), newCol);
                            const moveSel = item.querySelector('.note-folder-move-select');
                            if (moveSel) {
                                moveSel.value = newCol;
                                moveSel.dataset.prev = newCol;
                            }
                        }
                        item.classList.remove('is-editing');
                        noteFormWrapper.style.display = 'none';
                        if (noteToggle) {
                            noteToggle.replaceChildren();
                            const plusIcon = document.createElement('i');
                            plusIcon.className = 'fa-solid fa-plus';
                            const labelSpan = document.createElement('span');
                            labelSpan.textContent = config.i18n?.prof_new_note || 'Нова нотатка';
                            noteToggle.appendChild(plusIcon);
                            noteToggle.appendChild(labelSpan);
                        }
                        if (oldCol !== newCol) {
                            adjustTabCount(oldCol || 'General', -1);
                            adjustTabCount(newCol || 'General', +1);
                        }
                        resetNoteForm();
                        return;
                    }
                }
                location.reload();
            } else {
                if (feedback) {
                    feedback.textContent = result.data?.message || 'Помилка збереження';
                    feedback.className = 'form-feedback form-feedback--error is-visible';
                }
            }
        } catch (err) {
            submitBtn.disabled = false;
            console.error('Save note failed:', err);
            if (feedback) {
                feedback.textContent = config.i18n?.save_error || 'Не вдалося зберегти нотатку. Перевірте з’єднання та спробуйте ще раз.';
                feedback.className = 'form-feedback form-feedback--error is-visible';
            }
        }
    });

    // Toggle note form button
    if (noteToggle && noteFormWrapper) {
        noteToggle.addEventListener('click', () => {
            const isHidden = noteFormWrapper.style.display === 'none' || !noteFormWrapper.style.display;
            noteToggle.replaceChildren();
            if (isHidden) {
                if (noteFormWrapper.parentElement !== placeholder) {
                    moveForm(placeholder, true);
                } else {
                    noteFormWrapper.style.display = 'block';
                }
                const xIcon = document.createElement('i');
                xIcon.className = 'fa-solid fa-xmark';
                const labelSpan = document.createElement('span');
                labelSpan.textContent = config.i18n?.prof_cancel || 'Скасувати';
                noteToggle.appendChild(xIcon);
                noteToggle.appendChild(labelSpan);
            } else {
                noteFormWrapper.style.display = 'none';
                resetNoteForm();
                if (noteFormWrapper.classList.contains('is-inline-edit')) {
                    document.querySelectorAll('.note-item.is-editing').forEach((item) => item.classList.remove('is-editing'));
                    moveForm(placeholder, false);
                }
                const plusIcon = document.createElement('i');
                plusIcon.className = 'fa-solid fa-plus';
                const labelSpan = document.createElement('span');
                labelSpan.textContent = config.i18n?.prof_new_note || 'Нова нотатка';
                noteToggle.appendChild(plusIcon);
                noteToggle.appendChild(labelSpan);
            }
        });
    }

    // Delete Note (delegated on notesContainer)
    notesContainer?.addEventListener('click', async (e) => {
        const btn = e.target.closest('.note-item__delete');
        if (!btn) return;

        if (!confirm(config.i18n?.prof_confirm_delete_note || 'Ви впевнені, що хочете видалити цю нотатку?')) return;
        const item = btn.closest('.note-item');
        const noteId = item?.getAttribute('data-id');
        const folder = item?.dataset.collection || '';
        const fd = new FormData();
        fd.append('action', 'united_auth_delete_note');
        fd.append('security', config.nonce);
        fd.append('id', noteId);
        if (currentLang) fd.append('lang', currentLang);

        try {
            const response = await fetch(config.ajax_url, { method: 'POST', body: fd });
            const result = await response.json();
            if (result.success) {
                item.remove();
                adjustTabCount('all', -1);
                adjustTabCount(folder || 'General', -1);
                const remaining = notesContainer.querySelectorAll('.note-item');
                if (remaining.length === 0) {
                    const currentPage = parseInt(notesContainer.dataset.currentPage, 10) || 1;
                    fetchNotesPage(Math.max(1, currentPage - 1));
                }
            }
        } catch (err) {
            console.error('Delete note failed:', err);
        }
    });

    // Edit Note
    document.addEventListener('click', (e) => {
        const editBtn = e.target.closest('.note-item__edit');
        if (!editBtn) return;

        const item = editBtn.closest('.note-item');
        const id = item.dataset.id;
        const content = item.querySelector('.note-item__content')?.innerHTML || '';
        const idInput = document.getElementById('note_id');
        const inlinePlaceholder = item.querySelector('.note-item__editor-placeholder');

        if (idInput) idInput.value = id;
        const noteCollection = item.dataset.collection || '';
        setCollectionValue(noteCollection === 'General' ? '' : noteCollection);
        const newFolderInput = noteForm.querySelector('#note_new_folder_name');
        if (newFolderInput) newFolderInput.value = '';
        if (inlinePlaceholder) moveForm(inlinePlaceholder, true);

        if (typeof tinyMCE !== 'undefined' && tinyMCE.get('note_content_editor')) {
            tinyMCE.get('note_content_editor').setContent(content);
        }
        item.classList.add('is-editing');
    });

    // Move Note via Select (delegated on notesContainer)
    notesContainer?.addEventListener('change', async (e) => {
        const select = e.target.closest('.note-folder-move-select');
        if (!select) return;

        const item = select.closest('.note-item');
        const noteId = item?.dataset.id;
        const newFolder = select.value;
        const prevFolder = select.dataset.prev || '';

        if (newFolder === prevFolder) return;

        const fd = new FormData();
        fd.append('action', 'united_auth_move_note');
        fd.append('note_id', noteId);
        fd.append('folder', newFolder);
        if (currentLang) fd.append('lang', currentLang);
        fd.append('security', config.nonce);

        try {
            const response = await fetch(config.ajax_url, { method: 'POST', body: fd });
            const res = await response.json();
            if (res.success) {
                item.dataset.collection = newFolder;
                select.dataset.prev = newFolder;
                updateCollectionBadge(item.querySelector('.note-item__collection'), newFolder);
                adjustTabCount(prevFolder || 'General', -1);
                adjustTabCount(newFolder || 'General', +1);

                const activeBtn = filterContainer?.querySelector('.saved-filter__btn.is-active[data-collection]');
                const activeCol = activeBtn ? activeBtn.dataset.collection : 'all';
                if (activeCol !== 'all' && activeCol !== newFolder && (activeCol !== 'General' || newFolder !== '')) {
                    item.remove();
                    const remaining = notesContainer.querySelectorAll('.note-item');
                    if (remaining.length === 0) {
                        const currentPage = parseInt(notesContainer.dataset.currentPage, 10) || 1;
                        fetchNotesPage(Math.max(1, currentPage - 1), activeCol);
                    }
                }
            } else {
                select.value = prevFolder;
                alert(res.data?.message || 'Не вдалося перемістити нотатку');
            }
        } catch (err) {
            select.value = prevFolder;
            console.error('Move note failed:', err);
        }
    });

    // Filter tab click
    filterContainer?.addEventListener('click', (e) => {
        const btn = e.target.closest('.saved-filter__btn[data-collection]');
        if (!btn) return;
        if (e.target.closest('.folder-delete-action') || filterContainer.classList.contains('is-managing')) return;

        filterContainer.querySelectorAll('.saved-filter__btn[data-collection]').forEach(b => {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        fetchNotesPage(1, btn.dataset.collection);
    });

    // Pagination link click delegation
    notesContainer?.addEventListener('click', (e) => {
        const pageLink = e.target.closest('.ua-pagination[data-collection="notes"] a.page-numbers');
        if (!pageLink) return;
        e.preventDefault();
        const url = new URL(pageLink.href, window.location.origin);
        const page = url.searchParams.get('notes_page') || 1;
        fetchNotesPage(page);
        history.pushState(null, '', pageLink.href);
    });

    // --- Folder Management Strip ---
    if (filterContainer) {
        const manageBtn = filterContainer.querySelector('.saved-filter__manage-btn');
        const addBtn = filterContainer.querySelector('.saved-filter__add-btn');
        const addForm = filterContainer.querySelector('.saved-filter__add-form');
        const confirmAdd = addForm?.querySelector('.confirm');
        const cancelAdd = addForm?.querySelector('.cancel');
        const addInput = addForm?.querySelector('input');

        const closeAddForm = () => {
            addForm?.classList.remove('is-visible');
            if (addInput) addInput.value = '';
        };

        addInput?.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                confirmAdd?.click();
            } else if (e.key === 'Escape') {
                e.preventDefault();
                closeAddForm();
            }
        });

        // Toggle Rename/Delete Mode
        manageBtn?.addEventListener('click', () => {
            const isEditing = filterContainer.classList.toggle('is-managing');
            filterContainer.querySelectorAll('.folder-name').forEach(span => {
                const btn = span.closest('.saved-filter__btn');
                if (btn && btn.dataset.collection !== 'all' && btn.dataset.collection !== 'General') {
                    span.contentEditable = isEditing ? 'true' : 'false';
                    if (isEditing) {
                        span.dataset.oldName = span.textContent.trim();
                        span.addEventListener('keydown', handleRenameKeydown);
                        span.addEventListener('blur', handleRenameBlur);
                    } else {
                        span.removeEventListener('keydown', handleRenameKeydown);
                        span.removeEventListener('blur', handleRenameBlur);
                    }
                }
            });
            manageBtn.classList.toggle('is-active', isEditing);
            manageBtn.setAttribute('aria-pressed', isEditing ? 'true' : 'false');
        });

        const handleRenameKeydown = (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                e.target.blur();
            }
            if (e.key === 'Escape') {
                e.target.textContent = e.target.dataset.oldName;
                e.target.blur();
            }
        };

        const handleRenameBlur = async (e) => {
            const span = e.target;
            const newName = span.textContent.trim();
            const oldName = span.dataset.oldName;

            if (newName === oldName || !newName) {
                span.textContent = oldName;
                return;
            }

            const fd = new FormData();
            fd.append('action', 'united_auth_rename_folder');
            fd.append('old_name', oldName);
            fd.append('new_name', newName);
            if (currentLang) fd.append('lang', currentLang);
            fd.append('security', config.nonce);

            try {
                const response = await fetch(config.ajax_url, { method: 'POST', body: fd });
                const res = await response.json();
                if (res.success) {
                    span.dataset.oldName = newName;
                    const btn = span.closest('.saved-filter__btn');
                    if (btn) btn.dataset.collection = newName;

                    const isInScope = (item) => !currentLang || !item.dataset.lang || item.dataset.lang === currentLang;

                    // Update note items only within server scope without selector injection
                    document.querySelectorAll('.note-item').forEach(c => {
                        if (c.dataset.collection === oldName && isInScope(c)) {
                            c.dataset.collection = newName;
                            updateCollectionBadge(c.querySelector('.note-item__collection'), newName);
                        }
                    });

                    // Update custom dropdowns
                    document.querySelectorAll('#note-collection-select .custom-select__option').forEach(opt => {
                        if (opt.dataset.value === oldName) {
                            opt.dataset.value = newName;
                            opt.textContent = newName;
                        }
                    });

                    // Update move selects
                    document.querySelectorAll('.note-folder-move-select option').forEach(opt => {
                        if (opt.value === oldName) {
                            opt.value = newName;
                            opt.textContent = newName;
                        }
                    });

                    updateFilterCounts();
                } else {
                    span.textContent = oldName;
                    if (res.data?.message) alert(res.data.message);
                }
            } catch (err) {
                span.textContent = oldName;
                console.error('Rename folder failed:', err);
            }
        };

        // Add Folder
        addBtn?.addEventListener('click', () => {
            addForm?.classList.add('is-visible');
            addInput?.focus();
        });

        cancelAdd?.addEventListener('click', () => {
            closeAddForm();
        });

        confirmAdd?.addEventListener('click', async () => {
            const name = addInput?.value.trim();
            if (!name) return;

            const fd = new FormData();
            fd.append('action', 'united_auth_create_folder');
            fd.append('folder_name', name);
            if (currentLang) fd.append('lang', currentLang);
            fd.append('security', config.nonce);

            try {
                const response = await fetch(config.ajax_url, { method: 'POST', body: fd });
                const res = await response.json();
                if (res.success) {
                    const folderName = res.data?.created || name;

                    // Add tab
                    let existingBtn = Array.from(filterContainer.querySelectorAll('.saved-filter__btn')).find(b => b.dataset.collection === folderName);
                    if (!existingBtn) {
                        const newBtn = document.createElement('button');
                        newBtn.className = 'saved-filter__btn is-native-folder';
                        newBtn.dataset.collection = folderName;
                        newBtn.setAttribute('type', 'button');
                        newBtn.setAttribute('role', 'tab');
                        newBtn.setAttribute('aria-selected', 'false');

                        const folderIcon = document.createElement('i');
                        folderIcon.className = 'fa-solid fa-folder';
                        newBtn.appendChild(folderIcon);

                        const folderNameSpan = document.createElement('span');
                        folderNameSpan.className = 'folder-name';
                        folderNameSpan.setAttribute('contenteditable', 'false');
                        folderNameSpan.textContent = folderName;
                        newBtn.appendChild(folderNameSpan);

                        const countSpan = document.createElement('span');
                        countSpan.className = 'saved-filter__count';
                        countSpan.textContent = '0';
                        newBtn.appendChild(countSpan);

                        const delSpan = document.createElement('span');
                        delSpan.className = 'folder-delete-action';
                        delSpan.title = config.i18n?.delete || 'Видалити';
                        delSpan.setAttribute('role', 'button');
                        delSpan.setAttribute('aria-label', config.i18n?.delete || 'Видалити');
                        const delIcon = document.createElement('i');
                        delIcon.className = 'fa-solid fa-xmark';
                        delSpan.appendChild(delIcon);
                        newBtn.appendChild(delSpan);

                        const controls = filterContainer.querySelector('.saved-filter__controls');
                        if (controls) {
                            filterContainer.insertBefore(newBtn, controls);
                        } else {
                            filterContainer.appendChild(newBtn);
                        }
                    }

                    // Add to #note-collection-select
                    const selectDropdown = document.querySelector('#note-collection-select .custom-select__dropdown');
                    if (selectDropdown) {
                        const exists = Array.from(selectDropdown.querySelectorAll('.custom-select__option')).some(opt => opt.dataset.value === folderName);
                        if (!exists) {
                            const opt = document.createElement('div');
                            opt.className = 'custom-select__option';
                            opt.dataset.value = folderName;
                            opt.textContent = folderName;
                            const newOpt = Array.from(selectDropdown.querySelectorAll('.custom-select__option')).find(o => o.dataset.value === '__new__');
                            if (newOpt) {
                                selectDropdown.insertBefore(opt, newOpt);
                            } else {
                                selectDropdown.appendChild(opt);
                            }
                        }
                    }

                    // Add to .note-folder-move-select
                    document.querySelectorAll('.note-folder-move-select').forEach(sel => {
                        const exists = Array.from(sel.querySelectorAll('option')).some(opt => opt.value === folderName);
                        if (!exists) {
                            const opt = document.createElement('option');
                            opt.value = folderName;
                            opt.textContent = folderName;
                            sel.appendChild(opt);
                        }
                    });

                    closeAddForm();
                } else {
                    alert(res.data?.message || 'Не вдалося створити папку');
                }
            } catch (err) {
                console.error('Create folder failed:', err);
            }
        });

        // Delete Folder
        filterContainer.addEventListener('click', async (e) => {
            const delBtn = e.target.closest('.folder-delete-action');
            if (!delBtn) return;

            const btn = delBtn.closest('.saved-filter__btn');
            const folder = btn?.dataset.collection;
            if (!folder || folder === 'all' || folder === 'General') return;

            if (!confirm(config.i18n?.prof_confirm_delete_folder || `Видалити спільну папку "${folder}" та всі нотатки й збереження в ній?`)) return;

            const fd = new FormData();
            fd.append('action', 'united_auth_delete_folder');
            fd.append('folder', folder);
            if (currentLang) fd.append('lang', currentLang);
            fd.append('security', config.nonce);

            try {
                const response = await fetch(config.ajax_url, { method: 'POST', body: fd });
                const res = await response.json();
                if (res.success) {
                    const wasActive = btn.classList.contains('is-active');
                    const delCount = parseInt(btn.querySelector('.saved-filter__count')?.textContent, 10) || 0;
                    btn.remove();
                    adjustTabCount('all', -delCount);

                    if (wasActive) {
                        const allBtn = Array.from(filterContainer.querySelectorAll('.saved-filter__btn')).find(b => b.dataset.collection === 'all');
                        if (allBtn) {
                            filterContainer.querySelectorAll('.saved-filter__btn').forEach(b => {
                                b.classList.remove('is-active');
                                b.setAttribute('aria-selected', 'false');
                            });
                            allBtn.classList.add('is-active');
                            allBtn.setAttribute('aria-selected', 'true');
                        }
                    }

                    // Remove option from dropdowns
                    document.querySelectorAll('#note-collection-select .custom-select__option').forEach(opt => {
                        if (opt.dataset.value === folder) opt.remove();
                    });
                    document.querySelectorAll('.note-folder-move-select option').forEach(opt => {
                        if (opt.value === folder) opt.remove();
                    });

                    fetchNotesPage(1, wasActive ? 'all' : (filterContainer.querySelector('.saved-filter__btn.is-active[data-collection]')?.dataset.collection || 'all'));
                } else {
                    alert(res.data?.message || 'Не вдалося видалити папку');
                }
            } catch (err) {
                console.error('Delete folder failed:', err);
            }
        });
    }

    // "New folder" toggle in note form
    const collectionSelect = document.getElementById('note-collection-select');
    const newFolderWrap = document.getElementById('note-new-folder-wrap');
    if (collectionSelect && newFolderWrap) {
        const hiddenInput = collectionSelect.querySelector('input[type="hidden"]');
        if (hiddenInput) {
            hiddenInput.addEventListener('change', () => {
                const isNew = hiddenInput.value === '__new__';
                newFolderWrap.style.display = isNew ? 'block' : 'none';
                if (isNew) {
                    newFolderWrap.querySelector('input')?.focus();
                }
            });
        }

        // Observer fallback for label text mutation
        const label = collectionSelect.querySelector('.custom-select__label');
        if (label) {
            const observer = new MutationObserver(() => {
                const input = collectionSelect.querySelector('input[type="hidden"]');
                if (input && input.value === '__new__') {
                    newFolderWrap.style.display = 'block';
                    newFolderWrap.querySelector('input')?.focus();
                } else {
                    newFolderWrap.style.display = 'none';
                }
            });
            observer.observe(label, { childList: true, characterData: true, subtree: true });
        }
    }
};
